import React from 'react'

export default function TalentDB() {
  return (
    <div>TalentDB</div>
  )
}
